import type { FC } from "react";
import { AppImage } from "@/src/components/NextImage";
import { cn } from "utils";
import { SIGN_IN_INTRO_ASSETS } from "./introSlidesConfig";

interface IntroEdAvatarProps {
  className?: string;
}

/** Figma 96293:46184 — Ed avatar (48×48, intro-ed-avatar.webp). */
export const IntroEdAvatar: FC<IntroEdAvatarProps> = ({ className }) => (
  <div
    className={cn("size-12 shrink-0", className)}
    data-node-id="96293:46184"
    data-testid="intro-ed-avatar"
  >
    <AppImage
      src={SIGN_IN_INTRO_ASSETS.edAvatar}
      alt=""
      width={48}
      height={48}
      className="size-12 rounded-full"
      onError={(e) => {
        (e.target as HTMLImageElement).style.display = "none";
      }}
    />
  </div>
);
